const PolicyCategoriesFilter = category => ({
  name: 'category',
  value: category,
  operator: '',
  type: 'Category',
  displayValue: category,
});

export default PolicyCategoriesFilter;
